import React, { useState, useEffect } from 'react';
import axios from 'axios';

const ReserchTable = () => {
  const [labs, setLabs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLabs = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/researchlabs`);
        setLabs(response.data);
      } catch (err) {
        console.error('Error fetching research labs:', err);
        setError('Failed to fetch research labs.');
      } finally {
        setLoading(false);
      }
    };

    fetchLabs();
  }, []);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;

  return (
    <div style={{ maxHeight: '480px', overflowY: 'auto' }} className='ps-4'>
    <h4 className="text-center mb-3" style={{ color: 'navy' }}>Researchlab List</h4>
  <table className="table table-striped table-bordered table-hover rounded-5">
<thead style={{ position: 'sticky', top: 0, backgroundColor: '#fff', zIndex: 10 }}>
          <tr>
            <th>Lab ID</th>
            <th>Lab Name</th>
            <th>Lab Description</th>
            <th>Lab Head</th>
            <th>Head Contact</th>
            <th>Head Email</th>
            <th>Head Specialization</th>
            <th>Department</th>
            <th>Department Description</th>
          </tr>
        </thead>
        <tbody>
          {labs.length === 0 ? (
            <tr><td colSpan="9" className="text-center">No research labs available</td></tr>
          ) : (
            labs.map((lab) => (
              <tr key={lab.labId}>
                <td>{lab.labId}</td>
                <td>{lab.labName}</td>
                <td>{lab.labDesc}</td>
                <td>{lab.labHead?.username || 'N/A'}</td>
                <td>{lab.labHead?.contactNumber || 'N/A'}</td>
                <td>{lab.labHead?.email || 'N/A'}</td>
                <td>{lab.labHead?.specialization || 'N/A'}</td>
                <td>{lab.labHead?.department?.deptName || 'N/A'}</td>
                <td>{lab.labHead?.department?.deptDesc || 'N/A'}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ReserchTable;
